import React, { useState } from 'react';
import fetchAPI from '../../../common/fetchAPI';
import { ShowToast } from '../../../common/Toastr';
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
// import { } from "../TaskSlice";
import { Gantt, Task, EventOption, StylingOption, ViewMode, DisplayOption } from 'gantt-task-react';
import "gantt-task-react/dist/index.css";

import { GanttComponent, EditDialogFieldsDirective, DayMarkers, EditDialogFieldDirective, Inject, Edit, Selection, Toolbar, ColumnsDirective, ColumnDirective, EventMarkersDirective, EventMarkerDirective} from '@syncfusion/ej2-react-gantt';
import '../../../App.css';

import TaskAddUpdate from '../task/TaskAddUpdate';


const GanttChart = (props: any) => {
  const currentDate = new Date();
  // let taskss: Task[] = [
  //     {
  //         start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
  //         end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 15),
  //         name: "Some Project",
  //         id: "ProjectSample",
  //         progress: 25,
  //         type: "project",

  //         hideChildren: false
  //       },
  //       {
  //         start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
  //         end: new Date(
  //           currentDate.getFullYear(),
  //           currentDate.getMonth(),
  //           2,
  //           12,
  //           28
  //         ),
  //         name: "Idea",
  //         id: "Task 0",
  //         progress: 120,
  //         type: "task",
  //         project: "ProjectSample"
  //       },
  //       {
  //         start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2),
  //         end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 4, 0, 0),
  //         name: "Research",
  //         id: "Task 1",
  //         progress: 25,
  //         dependencies: ["Task 0"],
  //         type: "task",
  //         project: "ProjectSample"
  //       },
  //       {
  //         start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 4),
  //         end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 8, 0, 0),
  //         name: "Discussion with team",
  //         id: "Task 2",
  //         progress: 10,
  //         dependencies: ["Task 1"],
  //         type: "task",
  //         project: "ProjectSample"
  //       },
  //       {
  //         start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 8),
  //         end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 9, 0, 0),
  //         name: "Developing",
  //         id: "Task 3",
  //         progress: 2,
  //         dependencies: ["Task 2"],
  //         type: "task",
  //         project: "ProjectSample"
  //       },
  //       {
  //         start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 8),
  //         end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 10),
  //         name: "Review",
  //         id: "Task 4",
  //         type: "task",
  //         progress: 70,
  //         dependencies: ["Task 2"],
  //         project: "ProjectSample"
  //       },
  //       {
  //         start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 15),
  //         end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 15),
  //         name: "Release",
  //         id: "Task 6",
  //         progress: currentDate.getMonth(),
  //         type: "milestone",
  //         dependencies: ["Task 4"],
  //         project: "ProjectSample"
  //       },
  //       {
  //         start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 18),
  //         end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 19),
  //         name: "Party Time",
  //         id: "Task 9",
  //         progress: 0,
  //         isDisabled: true,
  //         type: "task"
  //       }
  // ]
  // const [tasks, setTasks] = useState<Task[]>(taskss);
  // const handleDblClick = (task: Task) => {
  //   alert("On Double Click event Id:" + task.id);
  // };
  // const handleTaskChange = (task: Task) => {
  //   console.log("On date change Id:" + task.id);
  //   let newTasks = tasks.map((t) => (t.id === task.id ? task : t));
  //   if (task.project) {
  //     const [start, end] = getStartEndDateForProject(newTasks, task.project);
  //     const project =
  //       newTasks[newTasks.findIndex((t) => t.id === task.project)];
  //     if (
  //       project.start.getTime() !== start.getTime() ||
  //       project.end.getTime() !== end.getTime()
  //     ) {
  //       const changedProject = { ...project, start, end };
  //       newTasks = newTasks.map((t) =>
  //         t.id === task.project ? changedProject : t
  //       );
  //     }
  //   }
  //   setTasks(newTasks);
  // };
  // const handleProgressChange = async (task: Task) => {
  //   setTasks(tasks.map((t) => (t.id === task.id ? task : t)));
  //   console.log("On progress change Id:" + task.id);
  // };
  // const getStartEndDateForProject = (tasks: Task[], projectId: string) => {
  //   const projectTasks = tasks.filter((t) => t.project === projectId);
  //   let start = projectTasks[0].start;
  //   let end = projectTasks[0].end;

  //   for (let i = 0; i < projectTasks.length; i++) {
  //     const task = projectTasks[i];
  //     if (start.getTime() > task.start.getTime()) {
  //       start = task.start;
  //     }
  //     if (end.getTime() < task.end.getTime()) {
  //       end = task.end;
  //     }
  //   }
  //   return [start, end];
  // };
  // const handleExpanderClick = (task: Task) => {
  //   setTasks(tasks.map((t) => (t.id === task.id ? task : t)));
  //   console.log("On expander click Id:" + task.id);
  // };
  // const handleTaskDelete = (task: Task) => {
  //   const conf = window.confirm("Are you sure about " + task.name + " ?");
  //   if (conf) {
  //     setTasks(tasks.filter((t) => t.id !== task.id));
  //   }
  //   return conf;
  // };



  //////////

  let data = [
  //   {
  //     TaskID: 1,
  //     TaskName: 'Project Initiation',
  //     StartDate: new Date('04/02/2019'),
  //     EndDate: new Date('04/21/2019'),
  //     subtasks: [
  //         { TaskID: 2, TaskName: 'Identify Site location', StartDate: new Date('04/02/2019'), Duration: 4, Progress: 50 },
  //         { TaskID: 3, TaskName: 'Perform Soil test', StartDate: new Date('04/02/2019'), Duration: 4, Progress: 50 }
  //     ]
  // },
    {
      TaskID: 1,
      TaskName: 'Project One',
      StartDate: new Date('04/02/2019'),
      EndDate: new Date('04/21/2019'),
      subtasks: [
        { TaskID: 2, TaskName: 'Identify Site location', StartDate: new Date('04/02/2019'), Duration: 4, Progress: 50 },
        { TaskID: 3, TaskName: 'Perform Soil test', StartDate: new Date('04/02/2019'), Duration: 4, Progress: 50 },
        { TaskID: 4, TaskName: 'Soil test approval', StartDate: new Date('04/02/2019'), Duration: 4, Progress: 50 },
      ]
    },
    {
      TaskID: 5,
      TaskName: 'Project Two',
      StartDate: new Date('04/02/2019'),
      EndDate: new Date('04/21/2019'),
      subtasks: [
        { TaskID: 6, TaskName: 'Develop floor plan for estimation', StartDate: new Date('04/04/2019'), Duration: 3, Progress: 50 },
        { TaskID: 7, TaskName: 'List materials', StartDate: new Date('04/04/2019'), Duration: 3, Progress: 50 },
        { TaskID: 8, TaskName: 'Estimation approval', StartDate: new Date('04/04/2019'), Duration: 3, Progress: 50 }
      ]
    }
  ];
  //let taskSettings = { id: 'TaskID', name: 'TaskName', startDate: 'StartDate', endDate: 'EndDate', duration: 'Duration', progress: 'Progress', child: 'subtasks' };
  const taskSettings: any = {
    id: 'TaskID',
    name: 'TaskName',
    startDate: 'StartDate',
    endDate: 'EndDate',
    duration: 'Duration',
    progress: 'Progress',
    dependency: 'Predecessor',
    child: 'subtasks',
    notes: 'info',
    resourceInfo: 'resources'
  };
  const resourceFields: any = {
    id: 'resourceId',
    name: 'resourceName'
  };
  const editSettings: any = {
    allowAdding: true,
    allowEditing: true,
    allowDeleting: true,
    allowTaskbarEditing: true,
    showDeleteConfirmDialog: true
  };
  const splitterSettings: any = {
    columnIndex: 2
  };
  const gridLines: any = 'Both';
  const toolbar: any = ['Add', 'Edit', 'Update', 'Delete', 'Cancel', 'ExpandAll', 'CollapseAll', 'Indent', 'Outdent'];
  const timelineSettings: any = {
    topTier: {
      unit: 'Week',
      format: 'MMM dd, y',
    },
    bottomTier: {
      unit: 'Day',
    },
  };
  const labelSettings: any = {
    leftLabel: 'TaskName',
    rightLabel: 'resources'
  };
  const eventMarkerDay1: Date = new Date('4/17/2019');
  const eventMarkerDay2: Date = new Date('5/3/2019');
  const eventMarkerDay3: Date = new Date('6/7/2019');
  const eventMarkerDay4: Date = new Date('7/16/2019');

  return (
    <>
      <div className='row selectAllDiv'>
        <p>Gant Chart</p>
      </div>

      <div className='control-pane'>
        <div className='control-section'>
          <GanttComponent
          id='Editing' dataSource={data} dateFormat={'MMM dd, y'}
          treeColumnIndex={1} allowSelection={true}
          showColumnMenu={false} highlightWeekends={true} allowUnscheduledTasks={true} gridLines={gridLines}
          height='410px' toolbar={toolbar} editSettings={editSettings}  splitterSettings={splitterSettings}
           resourceFields={resourceFields}  taskFields={taskSettings} >
              {/* <ColumnsDirective>
            <ColumnDirective field='TaskID' width='80' ></ColumnDirective>
            <ColumnDirective field='TaskName' headerText='Job Name' width='250' clipMode='EllipsisWithTooltip'></ColumnDirective>
            <ColumnDirective field='StartDate'></ColumnDirective>
            <ColumnDirective field='Duration'></ColumnDirective>
            <ColumnDirective field='Progress'></ColumnDirective>
            <ColumnDirective field='Predecessor'></ColumnDirective>
          </ColumnsDirective> */}
          
          <Inject services={[Edit,  Selection, Toolbar, DayMarkers]} />
          </GanttComponent>
        </div></div>
      {/* <Gantt tasks={tasks}
            onDateChange={handleTaskChange}
            onDoubleClick={handleDblClick}
            onDelete={handleTaskDelete}
            onProgressChange={handleProgressChange}
            onExpanderClick={handleExpanderClick}
             /> */}
    </>
  )
}

export default GanttChart;